
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { Ordine, Lavorazione, StatoLavorazione, VariazioneLavorazione, Azione, ProgressoLavorazione } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import dayjs from 'dayjs';

@Component
export default class ProgressoOrdine extends Vue {

    get loading () {
        return store.state.loading;
    }

    private editMode = false;

    get lavorazioni(): Lavorazione[] {
        return store.state.gruppoLavorazioni.concat()
            .sort((lavA, lavB) => {
                if (lavA.priorita < lavB.priorita) { return 1; }
                if (lavA.priorita > lavB.priorita) { return -1; }
                if (lavA.dataConsegna > lavB.dataConsegna) { return 1; }
                if (lavA.dataConsegna < lavB.dataConsegna) { return -1; }
                if (lavA.progresso > lavB.progresso) { return 1; }
                if (lavA.progresso < lavB.progresso) { return -1; }
                return 0;                
            });
    }

    get numCol(): number {
        return this.headers.length - 1;
    }

    get headers(): any[] {
        let titoli = [];
        // ID riga
        titoli.push({ sortable: false })

        if(this.lavorazioni && this.lavorazioni.length > 0) {
            let tipoTaglia: any = this.lavorazioni[0].tipoTagliaDecodificato;
            for (let index = 1; index <= 16; index++) {
                const nomeProp = `taglia${index.toString().padStart(2, '0')}`;
                const valProp: string = tipoTaglia[nomeProp];
                
                let end = valProp == undefined || valProp == '';
                if(!end) {
                    titoli.push({ 
                        text: valProp,
                        value: valProp,
                        align: 'center',
                        sortable: false
                    });
                }
            }
        }
        //titoli.push({ sortable: false })
        return titoli;
    }

    get items(): any[] {
        let rows: any[] = [];

        // inizializzazione riga per contaggio totali del gruppo di lavorazioni (sommatoria dei totali specificati per ogni lavorazione per ogni singola taglia)
        let rigaTotaliOrdine: StatoValoriProgresso = { id: -3, desc: '', tipoRiga: 0, values: [] as ValoriProgresso[] };
        for (let index = 1; index <= this.numCol; index++) {
            rigaTotaliOrdine.values.push({ totale: 0, fatti: 0, rimanenti: 0});
        }

        // calcolo dei "residui parziali" di ogni lavorazione
        if(this.lavorazioni && this.lavorazioni.length > 0) {
            this.lavorazioni.forEach(lavorazione => {
                
                let capiTaglia: any = lavorazione.innerLavorazione;

                // Riga numero totali capi per lavorazione (tipoRiga: 0)
                let rigaTotali: StatoValoriProgresso = { id: -2, desc: lavorazione.id, tipoRiga: 0, values: [] as ValoriProgresso[] };

                for (let index = 1; index <= this.numCol; index++) {
                    const nomeProp = `capi${index.toString().padStart(2, '0')}`;
                    let valProp: number = Number(capiTaglia[nomeProp]);
                    valProp = isNaN(valProp) ? 0 : valProp;
                    
                    rigaTotali.values.push({ totale: valProp, fatti: 0, rimanenti: valProp});

                    rigaTotaliOrdine.values[index-1].totale += valProp;
                    rigaTotaliOrdine.values[index-1].rimanenti += valProp;
                }

                rows.push(rigaTotali);

                // righe progresso in modifica delle singole lavorazioni
                let progLav = this.getProgressoPerLavorazione(rigaTotali); // TODO: al momento obbligatorio eseguire questa riga per creare prog singole... valutare refactory
                if(this.editMode) {
                    rows.push(progLav);
                }

                // TODO: righe progresso già associate alla lavorazione (tipoRiga: 1)
                lavorazione.progressiLavorazione.forEach(prog => {
                    let valori = this.extractProgresso(prog);
                    
                    for (let index = 0; index < valori.length; index++) {
                        rigaTotali.values[index].fatti += valori[index];
                        rigaTotali.values[index].rimanenti -= valori[index];
                        rigaTotaliOrdine.values[index].fatti += valori[index];
                        rigaTotaliOrdine.values[index].rimanenti -= valori[index];
                    }
                });          
            });
        }

        // riga progresso corrente editabile (tipoRiga: 2)
        if(!this.editMode) {
            rows.unshift(this.progressoValoriTotali);
        }
        // riga totali generali di tutte le lavorazioni (tipoRiga: _)
        rows.unshift(rigaTotaliOrdine);

        return rows;
    }

    get userIsAdmin() {
        return store.state.currentUsr.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined;
    }

    _progressiSingoleLavorazioni: any;
    _progressoValoriTotali: any = null;

    get progressoValoriTotali(): any {
        if(this._progressoValoriTotali == null || this._progressoValoriTotali == undefined) {
            this._progressoValoriTotali = { id: -1, tipoRiga: 2, values: [] as number[] };
            this.headers.forEach((h, index) => { if(index < this.numCol) this._progressoValoriTotali.values.push(0) });
        }
        return this._progressoValoriTotali;
    }
    set progressoValoriTotali(progresso: any) {
        this._progressoValoriTotali = progresso;
    }

    private getProgressoPerLavorazione(rigaStatoLavorazione: StatoValoriProgresso): StatoValoriProgresso {
        let idLavorazione = rigaStatoLavorazione.desc;
        if(!this._progressiSingoleLavorazioni) this._progressiSingoleLavorazioni = {};
        if(!this._progressiSingoleLavorazioni[idLavorazione]) {
            let progressoLav = { id: -1, desc: rigaStatoLavorazione.desc, tipoRiga: 3, values: [] as ValoriProgresso[] };
            rigaStatoLavorazione.values.forEach((v: ValoriProgresso) => progressoLav.values.push({ totale: 0, fatti: 0, rimanenti: v.rimanenti}));
            this._progressiSingoleLavorazioni[idLavorazione] = progressoLav;
        }
        return this._progressiSingoleLavorazioni[idLavorazione];
    }

    extractProgresso(progresso: ProgressoLavorazione): number[] {
        let valori: number[] = [];

        for (let index = 1; index <= this.numCol; index++) {
            const nomeProp = `qtaTaglia${index.toString().padStart(2, '0')}`;
            const valProp = Number((progresso as any)[nomeProp]); 
            
            valori.push(valProp)
        }

        return valori;
    }

    // Gestione valori progresso (switch in edit mode, annullamento/invio dei progressi in edit)

    passaInModoEdit() {
        var totCapiProgresso = 0;
        //this.progressoValoriTotali.values.some((v: number) => totCapiProgresso += v);
        if(!this.progressoValoriTotali.values.some((v: number) => v > 0)) {
            store.commit(StoreMutations.SetMessaggiErrore, ["Nessun dato di progresso specificato!"]);
            return;
        }
        // TODO: "spalmare" valori di progresso totale nei progressi specifici per ogni lavorazione
        this.progressoValoriTotali.values.forEach((v: number, index: number) => {
            let valDaAssegnare = v;
            let idxLavorazione = 0;
            while(valDaAssegnare > 0 && idxLavorazione < this.lavorazioni.length) {
                let lav = this.lavorazioni[idxLavorazione];
                let progLav: StatoValoriProgresso = this._progressiSingoleLavorazioni[lav.id];
                if(progLav.values[index].rimanenti > 0) {
                    if(valDaAssegnare <= progLav.values[index].rimanenti) {
                        progLav.values[index].fatti = valDaAssegnare;
                        valDaAssegnare = 0;
                    }
                    else {
                        progLav.values[index].fatti = progLav.values[index].rimanenti;
                        valDaAssegnare -= progLav.values[index].rimanenti;
                    }
                }

                idxLavorazione++;
            }
        });
        this.editMode = true;
    }

    annullaModificaProgressi() {
        if(this.editMode) {
            this.editMode = false;
        }
        else {
            this.$emit('on-completed');
        }
    }

    async inviaModificaProgressi() {
        if(!this.lavorazioni || this.lavorazioni.length <= 0) return;

        let progressi: ProgressoLavorazione[] = [];

        Object.keys(this._progressiSingoleLavorazioni).forEach(idLav => {
            let progLav: StatoValoriProgresso = this._progressiSingoleLavorazioni[idLav];
            if(progLav.values.some(val => val.fatti > 0)) {
                progressi.push({
                    indice: -1,
                    stato: '',
                    idLavorazione: idLav,
                    qtaTaglia01: progLav.values.length > 0 ? progLav.values[0].fatti : 0,
                    qtaTaglia02: progLav.values.length > 1 ? progLav.values[1].fatti : 0,
                    qtaTaglia03: progLav.values.length > 2 ? progLav.values[2].fatti : 0,
                    qtaTaglia04: progLav.values.length > 3 ? progLav.values[3].fatti : 0,
                    qtaTaglia05: progLav.values.length > 4 ? progLav.values[4].fatti : 0,
                    qtaTaglia06: progLav.values.length > 5 ? progLav.values[5].fatti : 0,
                    qtaTaglia07: progLav.values.length > 6 ? progLav.values[6].fatti : 0,
                    qtaTaglia08: progLav.values.length > 7 ? progLav.values[7].fatti : 0,
                    qtaTaglia09: progLav.values.length > 8 ? progLav.values[8].fatti : 0,
                    qtaTaglia10: progLav.values.length > 9 ? progLav.values[9].fatti : 0,
                    qtaTaglia11: progLav.values.length > 10 ? progLav.values[10].fatti : 0,
                    qtaTaglia12: progLav.values.length > 11 ? progLav.values[11].fatti : 0,
                    qtaTaglia13: progLav.values.length > 12 ? progLav.values[12].fatti : 0,
                    qtaTaglia14: progLav.values.length > 13 ? progLav.values[13].fatti : 0,
                    qtaTaglia15: progLav.values.length > 14 ? progLav.values[14].fatti : 0,
                    qtaTaglia16: progLav.values.length > 15 ? progLav.values[15].fatti : 0
                });
            }
        });

        if(progressi.length <= 0) {
            alert("Nessun dato di progresso specificato per l'invio!");
            return;
        }

        await store.dispatch(StoreActions.InvioProgressi, progressi);

        this.$emit('on-completed');
    }
}

interface ValoriProgresso { 
    totale: number, 
    fatti: number, 
    rimanenti: number
}

interface StatoValoriProgresso { 
    id: number,
    desc: string,
    tipoRiga: number,
    values: ValoriProgresso[]
}

